import React, { useState, useRef, useEffect } from "react";
import { Image as KonvaImage, Layer, Stage, Text as KonvaText } from "react-konva";
import { Toaster } from 'react-hot-toast';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { } from 'emoji-picker-element';

import { CanvasPhoto } from './components/CanvasPhoto';

// import badge1 from '../src/assets/img/badge1.png';
// import badge2 from '../src/assets/img/badge2.png';
// import badge3 from '../src/assets/img/badge3.png';
// import badge4 from '../src/assets/img/badge4.png';
// import badge5 from '../src/assets/img/badge5.png';
import badge6 from '../src/assets/img/badge6.png';
import badge7 from '../src/assets/img/badge6-1.png';
import badge8 from '../src/assets/img/badge6-2.png';
// import badge9 from '../src/assets/img/badge9.png';

import { FileUploader } from "react-drag-drop-files";



export default function App() {
  const sceneSize = { x: 1200, y: 1200 };

  let [photoRef, setPhotoRef] = useState({ data: null, x: 0, y: 0, w: 1200, h: 1200 });
  // let [text, setText] = useState("");
  let [imageProps, setImageProps] = useState({ x: 0, y: 0, w: 1200, h: 1200 });
  let [loading] = useState(false);
  let [uri, setUri] = useState(null);
  let [showGenerate, setShowGenerate] = useState(false);
  const stageRef = useRef(null);
  let emojiRef = useRef(null);
  let petNameInput = useRef(null);
  let [template, setTemplate] = useState(null);
  let [petName, setPetName] = useState("");
  let emojiUnicodeRef = useRef(null);

  const [show, setShow] = useState(false);

  const handleClose = (e) => {
    setShow(false)
  };
  const handleShow = () => setShow(true);


  const calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
    var ratio = Math.max(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
  };



  useEffect(() => {
    if(emojiRef.current) {
      emojiRef.current.addEventListener('emoji-click', event => {
        // console.log(event.detail);
        emojiUnicodeRef.current = event.detail.unicode;
        handlepetname(petName, event.detail.unicode, true);
         setTimeout(() => {
           handleClose();
         }, 10);
      });
    }
  })

  const generateImage = (file, cb) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      let img = new window.Image();
      img.src = e.target.result;

      img.onload = function () {
        const imgR = calculateAspectRatioFit(img.naturalWidth, img.naturalHeight, 1200, 1200);

        setImageProps({
          x: 0,
          y: 0,
          w: imgR.width,
          h: imgR.height,
        });
        cb(img);
      };
    };
    reader.readAsDataURL(file);
  };

  // const handleKeyDown = (e) => {
  //   setShowGenerate(false);
  //   setText((s) => (s = e.target.value));
  // };

  const handleExport = () => {
    setTimeout(() => {
      setUri(uri);
      downloadURI(uri, "my_pet_populaire.png");
    }, 100);
  };

  function downloadURI(uri, name) {
    setTimeout(() => {
      //setHideStage(s => s = false);
      const uri = stageRef.current.toDataURL();
      setUri(uri);

      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 10);
  }

  // function handleGenerate() {
  //   if(text === '') {
  //     return toast('Tchouff, tu as oublié ton pseudo');
  //   }
  // }

  function handlepetname(name, emoji = emojiUnicodeRef?.current || "❤️", mode = false) {

    setPetName(() => {
      if(name?.target?.value === "") {
        return null;
      }
      if(mode) {
        return petNameInput.current.value + ' ' + emoji + "\n soutient le NFP ✊";
      } else {
        return name.target.value + ' ' + emoji + "\n soutient le NFP ✊";
      }
    })

  }

  async function selectTemplate(selectedTemplate) {
    const bb = await fetch(selectedTemplate).then(r => r.blob())
    generateImage( bb, setTemplate );
    // handleGenerate();
  }

  const generatePhoto = (file) => {
    // setImageText(file.name);
    setShowGenerate(true);
    const reader = new FileReader();
    reader.onload = function (e) {
      let img = new window.Image();
      img.src = e.target.result;

      img.onload = function () {
        const imgR = calculateAspectRatioFit(img.naturalWidth, img.naturalHeight, 1200, 1200);

        setImageProps({
          x: sceneSize.x / 2 - imgR.width / 2,
          y: sceneSize.y / 2 - imgR.height / 2,
          w: imgR.width,
          h: imgR.height,
        });
        setPhotoRef(s => {
          return {...s, data: img, x: sceneSize.x / 2 - imgR.width / 2, y: sceneSize.y / 2 - imgR.height / 2, w: imgR.width, h: imgR.height }
        });
      };
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="container">
    {/* <div class="container"> */}

    {/* </div> */}

    <main className="app">
      <div className="row align-items-center app-child">
        <div className="col-md-12">
          <h1 className="mb-5 fs-9 fw-bold side text-center py-4">
            <span className="">Génère </span>
            <span className="red">ta photo <span style={{ textTransform: "capitalize" }}>#MyPetPopulaire</span></span>
          </h1>
        </div>
        <div className="col-md-12 d-flex justify-content-center mb-5">
          <FileUploader
            multiple={false}
            handleChange={generatePhoto}
            name="file"
            hoverTitle="Photo de votre animal"
            // types={fileTypes}
          />
        </div>

        { photoRef?.data && (
        <div className="col-md-6 text-md-start text-center py-6 col-left">


          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">Nom</span>
            </div>
            <input type="text" ref={petNameInput} onChange={handlepetname} className="form-control" placeholder="Nom de l'animal" aria-label="Nom de l'animal" aria-describedby="basic-addon1" />


            <Button variant="primary" onClick={handleShow}>{ emojiUnicodeRef?.current || '❤️' }</Button>
            {/* <emoji-picker style={{visibility: 'hidden', position: 'absolute'}}  ></emoji-picker> */}
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Emoji { }</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: 'auto' }}>
                <emoji-picker ref={emojiRef} ></emoji-picker>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                  Fermer
                </Button>
              </Modal.Footer>
          </Modal>

          </div>

          <div className="text-center text-md-start">
            <div className="badges mb-3">
              <p className="mb-3">Selectionnez un filtre</p>
              <ul>
                <li onClick={() => selectTemplate(badge6)} >
                  <img src={badge6} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge7)} >
                  <img src={badge7} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge8)} >
                  <img src={badge8} alt='img' className="fit-picture" />
                </li>
                {/* <li onClick={() => selectTemplate(badge4)} >
                  <img src={badge4} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge5)} >
                  <img src={badge5} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge6)} >
                  <img src={badge6} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge7)} >
                  <img src={badge7} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge8)} >
                  <img src={badge8} alt='img' className="fit-picture" />
                </li>
                <li onClick={() => selectTemplate(badge9)} >
                  <img src={badge9} alt='img' className="fit-picture" />
                </li> */}
              </ul>
            </div>
            {
              loading && (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )
            }
            <div className="text-right">
              <button className={`btn me-3 btn-lg export ${showGenerate ? "show" : "hidden"}`} onClick={handleExport}>Enregistrer</button>
            </div>
            {/* <a href="https://twitter.com/intent/tweet?url=myUrl&text=myTitle https://pic.twitter.com/kyQ3DWS9LH&name=medium&hashtags=quickbankingapp,USSD,ussd" target="_blank">Click to tweet</a> */}

          </div>
        </div>

          )}
        <div className="col-md-6 text-center m-auto col-right">
          <main>
          {photoRef?.data != null ? (
          <Stage width={sceneSize.x} height={sceneSize.y} ref={stageRef}>
            <Layer>
              <CanvasPhoto image={photoRef} />
            </Layer>


            <Layer>
                  <KonvaImage
                    image={template}
                    x={imageProps.x}
                    y={imageProps.y}
                    width={imageProps.w}
                    height={imageProps.h}
                  />
            </Layer>
            {petName && petName !== '' ? (
            <Layer>

              <KonvaText
                x={0}
                y={80}
                text={ petName  }
                align="center"
                fontSize={120}
                fontStyle="600"

                // fontFamily="obelixproregular"
                fill={"white"}
                width={1200}
                rotation={-3}
                shadowBlur={20}
                shadowOpacity={0.4}
                // stroke={"black"}
                // strokeEnabled={true}
                // strokeWidth={2}
                // draggable
              />

            </Layer>
            ) : <Layer></Layer> }



              {/* <KonvaText
                x={0}
                y={200}
                text={"soutient le NFP"}
                align="center"
                fontSize={120}
                // fontFamily="obelixproregular"
                fill={"white"}
                width={1200}
                rotation={-3}
                shadowBlur={20}
                shadowOpacity={0.4}
                // stroke={"black"}
                // strokeEnabled={true}
                // strokeWidth={2}
                // draggable
              /> */}

          </Stage>
          ) : (<h1>Choisir une photo</h1>) }
          {/* {template === null ? (<img  src={empty} alt="consigne" />) :

            (<div className="stage" style={{ position: "relative" }}>
              <Stage width={sceneSize.x} height={sceneSize.y} ref={stageRef} style={{borderRadius: '50%', overflow: 'hidden', width: '400px', margin: 'auto'}}>
                <Layer>
                  <KonvaImage
                    image={image}
                    x={imageProps.x}
                    y={imageProps.y}
                    width={imageProps.w}
                    height={imageProps.h}
                  />
                </Layer>

                <Layer>
                  <KonvaImage
                    image={template}
                    x={imageProps.x}
                    y={imageProps.y}
                    width={imageProps.w}
                    height={imageProps.h}
                  />
                </Layer>


              </Stage>
            </div>)
            } */}
          </main>


        </div>
      </div>

      <Toaster/>
    </main>
    </div>
  )
}
